import React from 'react';
import { connect } from "react-redux";
import { getPageDataAction } from "../../../store/troubleShooting/search/action";
import ArticleListComponent from "../../../components/troubleShooting/search/ArticleListComponent";
import { getArticleListAction, saveSearchOptionAction } from "../../../store/troubleShooting/search/action";
import defaultState from '../../../store/defaultStore';
import LoaderComponent from '../../../components/layout/loaderComponent';
import ErrorContainer from "../../../containers/ErrorContainer";
import ReactGA from 'react-ga4';

class ArticleListContainer extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      articleList: {},
      catSearch: false,
      loader: false,
      searchOption: {
        search_key: "",
        search_value: ""        
      },
      category_search: "",      
      searchPlaceHolder: 'default'
    }
    this.viewMoreResult = this.viewMoreResult.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  componentWillMount() {


    /* if( !this.props.location.state || !this.props.location.state.searchOption.search_value ){
      this.props.history.push({
        pathname: '/'
      });
    }else{ */
    defaultState.auth.userID = this.props.auth.auth.userId
    defaultState.searchReducer.searchOption.page = 1;
    defaultState.searchReducer.searchOption = (this.props.location.state) ? Object.assign(defaultState.searchReducer.searchOption, this.props.location.state.searchOption) : defaultState.searchReducer.searchOption;


    this.setState({
      searchOption: {
        search_value: this.props.location.state && this.props.location.state.searchOption && this.props.location.state.searchOption.search_value ? this.props.location.state.searchOption.search_value : '',
        search_key: this.props.location.state && this.props.location.state.searchOption && this.props.location.state.searchOption.search_key ? this.props.location.state.searchOption.search_key : 'free-text'
      },
      category_search: this.props.location.state && this.props.location.state.searchOption && this.props.location.state.searchOption.search_key === 'category' ? this.props.location.state.searchOption.category_names : ''
    });
    this.props.saveSearchOption(defaultState.searchReducer.searchOption);
    //}

  }


  /**
   * componentDidMount method to load pre needed data like page title, heading etc.
   */
  componentDidMount() {

    let searchOpt = { ...this.props.searchOption, page: 1, perpage: 10 };

    this.props.getPageData();
    if (searchOpt) {
      this.props.getArticleList({ searchOption: searchOpt }, { viewMore: false });
      window.scrollTo(0, 0);
    }
  }


  componentDidUpdate(prevProps, prevState) {
    
    if (prevProps.location.state && prevProps.location.state.searchOption && prevProps.location.state.searchOption !== this.props.location.state.searchOption) {
      defaultState.searchReducer.searchOption = { ...this.props.location.state.searchOption, page: 1, perpage: 10 };
     
      /*   this.setState({
          searchOption: {
            search_value: defaultState.searchReducer.searchOption.search_value,
            search_key: defaultState.searchReducer.searchOption.search_key
          }
        }); */

      this.props.saveSearchOption(defaultState.searchReducer.searchOption);

      this.setState({ 
        category_search: this.props.location.state && this.props.location.state.searchOption && this.props.location.state.searchOption.search_key === 'category' ? this.props.location.state.searchOption.category_names : ''
      });


      if (this.props.articleList.data)
        this.props.getArticleList({ searchOption: defaultState.searchReducer.searchOption });
      return true;
    } else {
      return false;
    }

    

    //this.props.getArticleList({ searchOption: this.props.location.state.searchOption }, { viewMore: false });
  }


  /**
   * @method: View More Result Handler viewMoreResult to load more result
   * @input: search_key, search_value, page, perpage  * 
   */
  viewMoreResult = () => {
    this.setState({
      loader: true
    });

    ReactGA.event('Click',{
      category: 'ListMore',
      action: 'Click',
      event_category: 'ListMore',
      event_action: 'Click',
      event_label: 'More',
      UserID: (this.props.auth.auth.userId) ?  this.props.auth.auth.userId : 'noAuth'
    });

    let searchOpt = Object.assign(this.props.searchOption, { page: this.props.searchOption.page + 1, perpage: this.props.searchOption.perpage });

    if (this.props.searchOption.perpage) {

      this.props.saveSearchOption(searchOpt);
      this.props.getArticleList({ searchOption: this.props.searchOption, viewMore: true });

      setTimeout(() => {
        this.setState({
          loader: false
        });
      }, 2000);

    }
  }

  /**
       * blurEvent
       */
  blurEvent = () => {
    this.setState({
      searchPlaceHolder: 'default'
    })
  }

  /**
   * focusEvent
   */
  focusEvent = () => {
    this.setState({
      searchPlaceHolder: ''
    })
  }


  /** @mthod onChangeHandler: To enable or disabled the search button on product category selection
   *  @parmas: current element
   *  @output: set disable true or false
   */
  onChangeHandler(e) {
    if (this.state.searchOption && this.state.searchOption.search_key === 'category') {
      this.setState({
        category_search: this.state.searchOption.category_names

      })

    }/* else{
      this.setState({
        category_search: this.state.searchOption.search_value

      })
    } */
    //if (e.target.value.trim() !=="" ) {

    this.setState({
      searchOption: {
        search_value: e.target.value,
        search_key: e.target.name
      }
    });

    defaultState.searchReducer.searchOption = { ...defaultState.searchReducer.searchOption, search_value: e.target.value, search_key: e.target.name };
    this.props.saveSearchOption(defaultState.searchReducer.searchOption);
    /* } else {

      defaultState.searchReducer.searchOption = { ...defaultState.searchReducer.searchOption, search_value: "", search_key: e.target.name };
      this.props.saveSearchOption(defaultState.searchReducer.searchOption);
    } */

  }


  /**
   * @method: Submit Handler onSubmitHandler to perform search operation
   * @input: search_key & search_value   * 
   */
  onSubmitHandler(e) {
    e.stopPropagation();
    e.preventDefault();
    //console.log(this.props.searchOption,'this.props.searchOption')
    // ReactGA.event({
    //   category: 'SearchByKeyword',
    //   action: 'Click',
    //   label: `${this.state.searchOption.search_value}`
    // });

    this.setState({
      loader: true,
      category_search: ''      
    });

    defaultState.searchReducer.searchOption = { ...defaultState.searchReducer.searchOption, page: 1, perpage: 10 };


    if (this.props.location && this.props.location.state && this.props.location.state.searchOption.search_value === defaultState.searchReducer.searchOption.search_value) {
      return;
    }



    this.props.getArticleList({ searchOption: defaultState.searchReducer.searchOption });

    //if(this.props.searchOption.search_value.trim() !==''){
   /*  setTimeout(() => {
      this.setState({
        loader: false
      });
    }, 2000); */
    //}
    
    this.props.history.push({
      pathname: '/troublesht/articles',
      state: { searchOption: { search_key: this.state.searchOption.search_key, search_value: this.state.searchOption.search_value } }
    });
  }

  /**
   *  @method: viewDetailClick to handle list click action and take it to article detail page
   *  @params: articleId along with search option like search key and value
   *  @output: none 
   */ 

  viewDetailClick = (articleId, title) => {

    ReactGA.event('Click', {
      category: 'LinkToAnswer',
      action: 'Click',
      event_category: 'LinkToAnswer',
      event_action: 'Click',
      event_label: `${title}`,
      UserID: (this.props.auth.auth.userId) ?  this.props.auth.auth.userId : 'noAuth'
      
    });

    this.props.history.push({
      pathname: '/troublesht/article/' + articleId,
      state: { searchOption: this.props.searchOption, title: title }
    });
  }

  /**
   * @render to load the view file
   */
  render() {

    return (

      this.props.articleList.data && this.props.articleList.data.hasOwnProperty('statusCode') ?
        (this.props.articleList.data.statusCode === 200 ?
          <ArticleListComponent pageData={this.props.pageData.data} articleList={this.props.articleList.data} searchOption={this.props.searchOption} viewMoreResultAction={this.viewMoreResult} showLoader={this.state.loader} changeEvent={this.onChangeHandler} submitEvent={this.onSubmitHandler} catSearch={this.state.catSearch} listClickEvent={this.viewDetailClick} focusEvent={this.focusEvent} blurEvent={this.blurEvent} searchPlaceHolder={this.state.searchPlaceHolder} category_search={this.state.category_search} /> : <ErrorContainer />) : <LoaderComponent />

    );
  }

}


/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  getPageData: getPageDataAction,
  getArticleList: getArticleListAction,
  saveSearchOption: saveSearchOptionAction
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  pageData: state.searchReducer.pageData,
  articleList: state.searchReducer.articleList,
  searchOption: state.searchReducer.searchOption,
  auth: state.auth

})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ArticleListContainer);